<template>
  <div>
    <div
      class="btn-group btn-group-toggle btn-block"
      :class="'false' ? 'float-left' : 'float-right'"
      data-toggle="buttons"
    >
      <label
        v-for="(option, index) in ChartPeriods"
        :key="option"
        class="btn btn-sm btn-success btn-simple"
        :class="{ active: period === index + 1 }"
        :id="index + 1"
      >
        <input
          type="radio"
          @click="updateCharts(index + 1)"
          name="options"
          autocomplete="off"
          :checked="period === index + 1"
        />
        {{ option }}
      </label>
    </div>
    <card type="topOperator">
      <div class="author">
        <div class="block block-one"></div>
        <div class="block block-two"></div>
        <div class="block block-three"></div>
        <div class="block block-four"></div>
        <a href="#">
          <img class="avatar" src="img/pp.jpg" alt="..." />
          <h5 class="title">
            {{ this.$t("dashboard.statisticsPanel.topOperatorCard.title") }}
          </h5>
        </a>
        <p class="description">
          {{ topOperator.operatorNumber }}
        </p>
        <p class="description">
          {{
            this.$t(
              "dashboard.statisticsPanel.topOperatorCard.answeredCallCount"
            )
          }}: {{ topOperator.answeredCallCount }}
        </p>
        <p class="description">
          {{
            this.$t(
              "dashboard.statisticsPanel.topOperatorCard.totalCallDuration"
            )
          }}: {{ topOperator.totalCallDuration }}
        </p>
      </div>
      <p></p>
    </card>
    <card type="chart">
      <template slot="header">
        <h5 class="card-category">
          {{ $t("dashboard.statisticsPanel.overallCallCountCard.title") }}
        </h5>
        <h3 class="card-title">
          <i class="tim-icons icon-bell-55 text-primary"></i>
          <!-- {{ overallCallCountChart.chartData.datasets[0].total }} -->
          Total : {{ overallCallCountChart.chartOptions.total }}
        </h3>
      </template>
      <div class="chart-area">
        <apexchart
          type="pie"
          width="100%"
          :options="overallCallCountChart.chartOptions"
          :series="overallCallCountChart.chartOptions.series"
        ></apexchart>
      </div>
    </card>

    <card type="chart">
      <template slot="header">
        <h5 class="card-category">
          {{ $t("dashboard.statisticsPanel.overallCallDurationCard.title") }}
        </h5>
        <h3 class="card-title">
          <i class="tim-icons icon-bell-55 text-primary"></i>
          <!-- {{ overallCallCountChart.chartData.datasets[0].total }} -->
          Total : {{ overallCallDurationChart.chartOptions.total }}
        </h3>
      </template>
      <div class="chart-area">
        <apexchart
          type="radialBar"
          width="100%"
          :options="overallCallDurationChart.chartOptions"
          :series="overallCallDurationChart.chartOptions.series"
        ></apexchart>
      </div>
    </card>

    <!-- <card type="chart">
            <template slot="header">
              <h5 class="card-category">
                {{ $t("dashboard.totalCalls") }}
              </h5>
              <h3 class="card-title">
                <i class="tim-icons icon-bell-55 text-primary"></i> 315
              </h3>
            </template>
            <div class="chart-area">
              <line-chart
                style="height: 100%"
                chart-id="purple-line-chart"
                :chart-data="purpleLineChart.chartData"
                :extra-options="purpleLineChart.extraOptions"
              >
              </line-chart>
            </div>
          </card>
          <card type="chart">
            <template slot="header">
              <h5 class="card-category">
                {{ $t("dashboard.dailySales") }}
              </h5>
              <h3 class="card-title">
                <i class="tim-icons icon-phone text-info"></i>
                357min
              </h3>
            </template>
            <div class="chart-area">
              <bar-chart
                style="height: 100%"
                chart-id="blue-bar-chart"
                :chart-data="blueBarChart.chartData"
                :gradient-stops="blueBarChart.gradientStops"
                :extra-options="blueBarChart.extraOptions"
              >
              </bar-chart>
            </div>
          </card>
          <card type="chart">
            <template slot="header">
              <h5 class="card-category">
                {{ $t("dashboard.completedTasks") }}
              </h5>
              <h3 class="card-title">
                <i class="tim-icons icon-send text-success"></i> 12,100K
              </h3>
            </template>
            <div class="chart-area">
              <line-chart
                style="height: 100%"
                ref="bigChart"
                chart-id="green-line-chart"
                :chart-data="greenLineChart.chartData"
                :gradient-stops="greenLineChart.gradientStops"
                :extra-options="greenLineChart.extraOptions"
              >
              </line-chart>
            </div>
          </card> -->
  </div>
</template>
<script>
import * as HTTPMethods from "@/helpers.js";

export default {
  data() {
    return {
      period: 2,
      topOperator: {},
      overallCallDuration: {},
      overallCallCount: {},
      overallCallDurationChart: {},
      overallCallCountChart: {
        chartOptions: {
          labels: ["Answered", "Not answered", "Other"],
          series: [0, 0, 0],
          total: 0,
          legend: {
            position: "top",
          },
        },
      },
      overallCallDurationChart: {
        chartOptions: {
          chart: {
            height: 280,
            type: "radialBar",
          },
          total: 0,
          series: [Math.round(1650 / 123)],
          labels: ["salam"],
          plotOptions: {
            radialBar: {
              hollow: {
                margin: 15,
                size: "70%",
              },

              dataLabels: {
                showOn: "always",
                name: {
                  offsetY: -10,
                  show: true,
                  color: "#888",
                  fontSize: "13px",
                },
                value: {
                  color: "#111",
                  fontSize: "30px",
                  show: true,
                },
              },
            },
          },

          stroke: {
            lineCap: "round",
          },
          labels: ["Actual Duration"],
        },
      },
      bigLineChart: {
        allData: [
          [100, 70, 90, 70, 85, 60, 75, 60, 90, 80, 110, 100],
          [80, 120, 105, 110, 95, 105, 90, 100, 80, 95, 70, 120],
          [60, 80, 65, 130, 80, 105, 90, 130, 70, 115, 60, 130],
        ],
        activeIndex: 0,
        chartData: {
          datasets: [{}],
          labels: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
          ],
        },
        gradientStops: [1, 0.4, 0],
        categories: [],
      },
    };
  },
  computed: {
    bigLineChartCategories() {
      return this.$t("dashboard.statisticsPanel.global.chartCategories");
    },
    ChartPeriods() {
      return this.$t("dashboard.statisticsPanel.global.chartCategories");
    },
  },
  methods: {
    initBigChart(index) {
      let chartData = {
        datasets: [
          {
            fill: true,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBorderColor: "rgba(255,255,255,0)",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: this.bigLineChart.allData[index],
          },
        ],
        labels: [
          "JAN",
          "FEB",
          "MAR",
          "APR",
          "MAY",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OCT",
          "NOV",
          "DEC",
        ],
      };
      //this.$refs.bigChart.updateGradients(chartData);
      this.bigLineChart.chartData = chartData;
      this.bigLineChart.activeIndex = index;
    },
    updateCharts(_period) {
      this.period = _period;

      localStorage.setItem("charts-period", this.period);

      HTTPMethods.TopOperatorGet(_period).then((response) => {
        this.topOperator = response;
      });

      HTTPMethods.OverallCallDurationGet(_period).then((response) => {
        this.overallCallDuration = response;
        let series = [
          Math.round(
            (+response["actualDuration"] * 100) / +response["totalDuration"]
          ),
        ];
        let total = response["actualDuration"];
        this.overallCallDurationChart.chartOptions.series = series;
        this.overallCallDurationChart.chartOptions.total = total;
      });

      HTTPMethods.OverallCallCountGet(_period).then((response) => {
        this.overallCallCount = response;
        let series = [];
        let total = 0;
        Object.keys(response).forEach((d) => {
          series.push(response[d]);
          total += response[d];
        });
        this.overallCallCountChart.chartOptions.series = series;
        this.overallCallCountChart.chartOptions.total = total;
        /*    if(_period==3){
          this.overallCallCountChart.chartOptions.series = [150,230,78];
          this.overallCallCountChart.chartOptions.total = 458; 
        } */
      });
    },
  },
  created() {
    /* localStorage.setItem("charts-period", this.period);
    HTTPMethods.TopOperatorGet(2).then((response) => {
      this.topOperator = response;
    });
    HTTPMethods.OverallCallDurationGet(2).then((response) => {
      this.overallCallDuration = response;
    });
    HTTPMethods.OverallCallCountGet(2).then((response) => {
      this.overallCallCount = response;
    }); */
    this.updateCharts(2);
  },
};
</script>
<style>
</style>
